<div class="packetfile cursorptr" (keyup)="downloadpacket($event)" (click)="downloadpacket($event)">{{params.value}}</div>
